module.exports = __webpack_public_path__ + "img/icon_real_time_2.435782b1.png";